import React from "react";
import { Link } from "react-router-dom";
import { Sprout } from "lucide-react";

export const Logo = ({ size = "md", className = "" }) => {
  const sz = size === "sm" ? "h-8 w-8" : size === "lg" ? "h-11 w-11" : "h-9 w-9";
  const text = size === "sm" ? "text-lg" : size === "lg" ? "text-2xl" : "text-xl";
  return (
    <Link to="/" className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <div className={`${sz} rounded-lg gradient-emerald flex items-center justify-center shadow-sm`}>
        <Sprout className="text-white" strokeWidth={2.5} size={size === "lg" ? 24 : 20} />
      </div>
      <div className="flex flex-col leading-tight">
        <span className={`font-heading font-bold text-gray-900 ${text}`}>Custora</span>
        {size !== "sm" && <span className="text-[10px] font-medium tracking-wider uppercase text-emerald-600">Customer Ownership</span>}
      </div>
    </Link>
  );
};

export default Logo;
